
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.952 9.952C7 12.905 7 17.657 7 27.16v1.68c0 9.503 0 14.255 2.952 17.208C12.905 49 17.657 49 27.16 49h1.68c9.503 0 14.255 0 17.208-2.952C49 43.095 49 38.343 49 28.84v-1.68c0-9.503 0-14.255-2.952-17.208C43.095 7 38.343 7 28.84 7h-1.68C17.657 7 12.905 7 9.952 9.952zm4.136 9.823c.227 10.92 5.687 17.483 15.26 17.483h.543V31.01c3.517.35 6.177 2.923 7.244 6.248h4.97c-1.365-4.97-4.952-7.718-7.192-8.768 2.24-1.295 5.39-4.445 6.142-8.715H36.54c-.98 3.465-3.884 6.615-6.65 6.913v-6.913h-4.515v12.11c-2.8-.7-6.335-4.095-6.492-12.11h-4.795z","fill":"#07F"}})])
          )
        }
      }
    